module.exports = __webpack_public_path__ + "img/logo_orias_inconnu.38578887.png";